import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, BusinessStatus } from './index';

export type BusinessCreateData = { id: string };

export type BusinessCreateResponse = BusinessCreateData

export interface BusinessCreateBody {
  name: string;
  description: string;
  fileId: string | null;
  address: string;
  phone: string;
  schedule: string;
  zipCode: string;
  email: string;
  type: string;
  website: string;
  categoryIds?: string[];
  subCategoryIds?: string[];
  userIds?: string[];
  status: BusinessStatus | null;
}

export const businessCreate = (payload: BusinessCreateBody): Action<BusinessCreateBody> => ({
  type: actions.businessCreateTrigger.toString(),
  payload,
});

export const businessCreateClear = (): Action => ({
  type: actions.businessCreateClear.toString(),
});

export const businessCreateErrorClear = (): Action => ({
  type: actions.businessCreateErrorReset.toString(),
});

export function* businessCreateRequestSaga({ payload }: Action<BusinessCreateBody>) {
  // eslint-disable-next-line no-unused-expressions,@typescript-eslint/no-unused-expressions
  ({ payload });
  yield put({
    type: actions.businessCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.businessCreateError.toString(),
      payload: {
        message: 'BusinessCreate: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/businesses`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<BusinessCreateData, BusinessCreateResponse>(
    response,
    actions.businessCreateSuccess.toString(),
    actions.businessCreateError.toString(),
    false,
    (businessCreateData) => businessCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.businessCreateTrigger.toString(),
    defaultProcessingSaga(
      businessCreateRequestSaga,
      {
        error: actions.businessCreateError.toString(),
        locationCancel: actions.businessCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.businessCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.businessCreateClear.toString(),
    // });
  });

  yield takeLatest(actions.businessCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.businessCreateErrorReset.toString(),
    });
  });
}
